import {GreetingService} from "./greeting.service";

export const GreetingInjectables: Array<any> = [
  {
    provide: GreetingService,
    useClass: GreetingService,
  },
];
